import { useEffect, useState, useContext } from "react";
import styles from "../../../../components/VideoDetails/partials/styles.module.scss";

// import eventSpeaker1 from "../../../../assets/images/networking/1.png";
// import eventSpeaker2 from "../../../../assets/images/networking/2.png";
// import eventSpeaker3 from "../../../../assets/images/networking/3.png";
// import eventSpeaker4 from "../../../../assets/images/networking/4.png";

import { isMobileDevice } from "../../../../utils/getPlatformInfo";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";
// import UserManager from "../../../../Managers/Users";
import { networkContext } from "../../../../contexts/NetworkContext/NetworkContextProvider";
import { NameAvatar } from "../../../../components/nameImage";

// const networkingList1 = [
//   {
//     name: "Dr.Raghu Satyanarayan",
//     designation: "",
//     city: "Noida",
//     photoUrl: eventSpeaker1,
//     common: 2,
//     events: 8,
//   },
//   {
//     name: "Dr.Adarsh Seth",
//     designation: "",
//     city: "Mumbai",
//     photoUrl: eventSpeaker2,
//     common: 4,
//     events: 6,
//   },
//   {
//     name: "Dr.Jay Shah",
//     designation: "",
//     city: "Kolkata",
//     photoUrl: eventSpeaker3,
//     common: 8,
//     events: 3,
//   },
//   {
//     name: "Dr. Rama K. Shetty",
//     designation: "",
//     city: "Delhi",
//     photoUrl: eventSpeaker4,
//     common: 5,
//     events: 7,
//   },
// ];

const Networking = ({ webinarID }) => {
  const { openChat, networkingUserData } = useContext(networkContext);
  const [networkingList, setNetworkingList] = useState([]);

  const {
    isChatBotOpen,
    setIsChatBotOpen,
    chatSectionStatus,
    toggleChatSection,
    userMetadata,
  } = useContext(UserContext);

  useEffect(() => {
    if (webinarID && (userMetadata?.userId || userMetadata?.id)) {
      setNetworkingList(networkingUserData);
    }
  }, [webinarID, userMetadata, networkingUserData]);

  // const getNetworkingData = async (data) => {
  //   let commonCount = {};
  //   let users = await Promise.all(
  //     data.map((_data) => {
  //       let { id } = _data;
  //       _data.webinars.forEach((_wid) => {
  //         if (userMetadata.webinars.indexOf(_wid) !== -1) {
  //           if (commonCount.hasOwnProperty(id)) {
  //             commonCount[id] += 1;
  //           } else {
  //             commonCount[id] = 1;
  //           }
  //         }
  //       });
  //       return UserManager._get.getUser(id);
  //     })
  //   );

  //   let _users = users.map((_uData) => ({
  //     ..._uData,
  //     common: commonCount[_uData.userid],
  //     photoUrl:
  //       networkingList1[Math.floor(Math.random() * networkingList1.length)]
  //         .photoUrl,
  //   }));

  //   setNetworkingList(_users);
  //   // console.log("_users:", _users);
  // };

  const handleClickBtn = (_userDetials) => {
    if (!isChatBotOpen) {
      setIsChatBotOpen(true);
      if (!chatSectionStatus) {
        toggleChatSection(true);
      }
    }
    _userDetials = {
      ..._userDetials,

      userid: _userDetials.id,
    };
    openChat(webinarID, _userDetials);
  };

  return (
    <div className={styles.speakersWrapper}>
      {networkingList.map((speaker, index) => {
        const {
          city = null,
          common = "",
          events = "",
          firstName = "",
          lastName = "",
          commonCount = 1,
          photoUrl = undefined,
        } = speaker;
        return (
          <div className={styles.speakerAndInfo} key={index}>
            <div
              className={styles.speakerCard}
              data-aos="zoom-in"
              data-aos-duration="200"
              data-aos-delay={index * 100}
              data-aos-easing="ease-in-sine"
              data-aos-once="true"
              style={{
                height: "27rem",
              }}
            >
              {photoUrl ? (
                <img
                  style={{
                    borderRadius: "unset",
                    backgroundColor: "unset",
                  }}
                  src={photoUrl}
                  alt={speaker.name}
                  className={styles.speakerImg}
                />
              ) : (
                <NameAvatar
                  width={"9.375rem"}
                  height={"9.375rem"}
                  firstName={firstName}
                  lastName={lastName}
                  classes={styles.speakerImg}
                  size={"2rem"}
                />
              )}

              <div
                style={{
                  flexDirection: `${isMobileDevice ? "row" : "column"}`,
                  alignItems: "center",
                }}
                className={styles.speakerDetails}
              >
                <div
                  style={{
                    display: `${isMobileDevice} ? "flex" : "block"`,
                    flexDirection: "column",
                  }}
                >
                  <div
                    className={styles.name}
                  >{`${firstName} ${lastName}`}</div>
                  <ul className={styles.infoList}>
                    {city && (
                      <li
                        className={styles.infoItem}
                        style={{ marginBottom: !isMobileDevice && "0.5rem" }}
                      >
                        {city}
                      </li>
                    )}
                    {events && (
                      <li className={styles.infoItem}>
                        {events} events attended
                      </li>
                    )}
                    {commonCount && (
                      <li className={styles.infoItem}>
                        {commonCount} in common
                      </li>
                    )}
                  </ul>
                </div>
                <button
                  className={`btn`}
                  onClick={() => handleClickBtn(speaker)}
                  style={{
                    height: "unset",
                    margin: "unset",
                    // marginTop: "0.2rem",
                    fontSize: isMobileDevice && "0.8rem",
                    padding: isMobileDevice ? "0.5rem" : "1rem 2rem",
                  }}
                >
                  Connect
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Networking;
